<!-- 首页-模块 vue -->
<template>
  <div class="training-apply-content">
    <theme-head
        :title="apply.title"
        :intro="apply.intro"
        :more="apply.more"
        :redirect="apply.redirect"
        :titleBg="apply.titleBg"
        :openUrl="apply.openUrl"
    ></theme-head>

    <div class="swiper-container-apply">
      <div class="swiper-wrapper">
        <div
            class="swiper-slide"
            v-for="(item, index) in projectList"
            :key="index"
        >
          <div class="video-wrap">
            <i class="play-pause" v-show="!videoPlaying"  @click.stop="toPlay(index,$event)"></i>
            <!-- poster="../../../public/images/home/play.png" -->
            <video
                :poster="item.imgUrl"
                class="video-apply"
                :id="'myVideo'+index"
                :src="item.videoUrl"
                :controls="true"
                :autoplay="false"
                @play="play"
                @pause="pause"
                controlslist="nodownload  noremoteplayback disablePictureInPicture "
                disablePictureInPicture
            >
            </video>
          </div>
          <div class="text-wrap">
            <div class="name">{{ item.videoName }}</div>
            <div class="desc">{{ item.videoDescribe }}</div>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>


<!--    <el-carousel-->
<!--        :interval="4000"-->
<!--        :autoplay ="false"-->
<!--        type="card"-->
<!--        height="450px"-->
<!--    >-->
<!--      <el-carousel-item-->
<!--          v-for="(item, index) in projectList"-->
<!--         :key="index">-->
<!--        <div class="video-wrap">-->
<!--          <video-->
<!--              :poster="item.imgUrl"-->
<!--              class="video-apply"-->
<!--              :id="'myVideo'+index"-->
<!--              :src="item.videoUrl"-->
<!--              :controls="true"-->
<!--              :autoplay="false"-->
<!--              @play="play"-->
<!--              @pause="pause"-->
<!--              controlslist="nodownload  noremoteplayback disablePictureInPicture "-->
<!--              disablePictureInPicture-->
<!--          >-->
<!--          </video>-->
<!--        </div>-->
<!--      </el-carousel-item>-->
<!--    </el-carousel>-->

  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import ThemeHead from "@/components/home/ThemeHead.vue";

export default {
  name: "trainingApply",
  components: { ThemeHead },
  props: {
    projectList: {
      Type: Array,
      default() {
        return [];
      }
    }
  },

  data() {
    let self = this;
    return {
      swiper: null,
      activeIndex: null,
      playIndex: null,
      videoPlaying: false,
      apply: {
        intro: "校企协同育人，多方课题合作，科技赋能产业",
        more: "进入应用",
        redirect: "/pretrain/2", // TIPS:  2 是模型训练里面的其中一个，图像分类
        titleBg: require("../../../public/images/home/head04.png"),
        openUrl: "application"
      },
      gtaVideo: null, //video.js 实例化对象
      videoUrl: "http://10.1.137.246:8062/UploadFiles/202010/202010541606541726.mp4",
      playbackStatus: false, // true-为播放完毕
      swiperOptions: {
        autoplay: false,
        setWrapperSize :true,
        roundLengths : true,
        slidesPerView: 2.2,
        spaceBetween: 20,
        effect: "coverflow", //'slide(普通切换、默认)','fade('淡入')','cube(方块)','coverflow(3d流)','flip(3d翻转)'
        centeredSlides: true, // 设置活动块居中
        loop: true,
        coverflowEffect: { // coverflow效果参数
          slideShadows: false // 是否开启slide阴影
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          touchMove: function(swiper) {
            // console.log("swiper", swiper);
          },
          slideChangeTransitionStart: function(swiper) {
            // console.log("swiper-start", swiper);
          },
          slideChangeTransitionEnd: function(swiper) {
            // console.log("this.activeIndex", this.activeIndex);
            // console.log("swiper-end", swiper);
            self.activeIndex = this.activeIndex;
          },
          click: function(swiper,event) {
            console.log("this.activeIndex", this.activeIndex,swiper,event);
            self.activeIndex = this.activeIndex;
          },
        }
      },
      videoOptions: {
        //video.js参数配置
        loop: true, // 循环播放
        controls: true, // true：视频操作区显示
        autoplay: false, //自动播放属性,muted:静音播放
        preload: "auto", //建议浏览器是否应在<video>加载元素后立即开始下载视频数据
        language: "zh-CN", // 设置语言
        controlBar: {
          playToggle: true,
          /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
          children: [
            {
              // 播放按钮
              name: "playToggle"
            },
            {
              // 当前播放时间
              name: "currentTimeDisplay"
            },
            {
              // 总时间
              name: "durationDisplay"
            },
            {
              // 播放进度条
              name: "progressControl"
            },
            {
              // 倍数播放
              name: "playbackRateMenuButton",
              playbackRates: [0.5, 1, 1.5, 2]
            },
            {
              // 音量控制
              name: "volumePanel",
              inline: false // 不使用水平方式
            },
            {
              // 全屏
              name: "FullscreenToggle"
            }, {
              // 按下
              text: "press"
            }
          ]
        },
        isFullscreen: true
      }
    };
  },
  computed: {},
  watch: {
    projectList: {
      handler(val) {
        if (val.length > 0) {
          let self = this;
          this.$nextTick(() => {
            let doms = document.querySelectorAll(".video-apply");
            doms = Array.from(doms)
            doms.forEach((dom, index) => {
              //监听播放
              dom.addEventListener("play", function() {
                self.playIndex = index;
                // self.videoPlaying = true;
                // console.log("播放开始videoPlaying", self.videoPlaying);
                self.swiper.autoplay.stop();//轮播停止
                // self.$forceUpdate();
              });
              //监听停止
              dom.addEventListener("pause", function() {
                self.swiper.autoplay.start();//轮播停止
                // self.videoPlaying = false;
                // console.log("播放结束videoPlaying", self.videoPlaying);
              });
            });
          });
        }
      },
      deep: true,
      immediate: true
    },
    activeIndex(val) {
      this.videopauseAll();//暂停播放

    },
    videoPlaying(val) {
      console.log("playing", val);
      this.$forceUpdate();
    }
  },
  created() {

  },
  mounted() {
    this.initSwiper();
    // this.initVideo();//初始化video.js
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper(".swiper-container-apply", this.swiperOptions);
    },
    initVideo() {
      //页面dom元素渲染完毕，执行回调里面的方法
      let self = this;
      this.$nextTick(() => {
        this.gtaVideo = this.$video(
            document.getElementById("myVideo0"),
            this.videoOptions
        );
        // 钩子：监听播放
        this.gtaVideo.on("play", function() {
          self.playbackStatus = false;
          self.swiper.stopAutoplay();//轮播停止
        });
        // 视频暂停时轮播图继续
        this.gtaVideo.on("pause", function() {
          self.swiper.startAutoplay();//轮播开始
        });
        // 钩子：监听结束
        this.gtaVideo.on("ended", function() {
          self.playbackStatus = true;
          //退出全屏
          if (self.gtaVideo.isFullscreen()) {
            self.exitFullscreenHandler();
          }
        });
        // 钩子：监听隐藏
        this.gtaVideo.on("hide", function() {
          self.gtaVideo.dispose();
        });
      });
    },
    onLive(val) {
      // this.$router.push({
      //   name: "application-live",
      //   query: { videoId: val }
      // });
    },
    toPlay(index, e) {
      console.log("index", index);
      this.videoPlaying = true;
      console.log(333, this.videoPlaying);
      // e.target.nextSibling.play();//通过e.target.nextSibling获取 对应需要播放的video 标签

      try {
        let doms = document.querySelectorAll(".video-apply");
        doms = Array.from(doms)
        doms[index].play();
      } catch (e) {
         console.log(e)
      }


    },
    // 全屏
    fullScreenHandler() {
      this.gtaVideo.requestFullscreen();
    },
    // 退出全屏
    exitFullscreenHandler() {
      this.gtaVideo.exitFullscreen();
    },
    // 播放
    play() {
      let self = this;
      this.videoPlaying = true;
      // this.swiperOptions.autoplay = false;
      // self.playbackStatus = false;
      // self.swiper.stopAutoplay();
    },
    // 暂停
    pause() {
      this.videoPlaying = false;
      // this.swiper.startAutoplay()
      // this.gtaVideo.pause();
    },
    // 暂停
    videopauseAll() {
      let activeIndex = this.activeIndex;
      let id = "myVideo" + activeIndex;
      let videoList = document.getElementsByClassName("video-apply");
      videoList.forEach(item => {
        if (item) {
          item.pause();
        }
      });
      // let dom = document.getElementById(id);
      // if (dom) {
      //   dom.pause();
      // }
      
      // this.gtaVideo.pause();
    }

  },
  updated() {
  },
  destroyed() {
  },
  activated() {
  }
};
</script>
<style lang="scss" scoped>
.training-apply-content {
  background: url(../../../public/images/home/training-project-bg.png);
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  padding: 0;
  position: relative;
  margin: 0 0 0 0;
  width: 100%;
  height: calc(100% - 80px);
  min-height: 800px;

  ::v-deep.theme-head {
    .theme-intro {
      margin-bottom: 0px;
      transform: translateY(-8px);
    }
  }

  ::v-deep.swiper-container-apply {
    width: 100%;
    height: 540px;
    //overflow: hidden;
    overflow-x: hidden;
    overflow-y: auto;
    margin: -50px 0 0 0;
    --swiper-navigation-color: #fff; /* 单独设置按钮颜色 */
    .swiper-slide {
      width: 100%;
      text-align: center;
      font-size: 18px;
      display: -webkit-flex;
      display: flex;
      align-items: center;

      .text-wrap {
        display: none;
      }
    }

    .swiper-slide-prev {
      .video-wrap {
        &:before {
          position: absolute;
          width: 100%;
          height: 500px;
          content: "";
          display: block;
          z-index: 99;
          margin-top: -10px;
          background: linear-gradient(to right, rgba(234, 236, 254, 1), rgba(234, 236, 254, 1), rgba(234, 236, 254, 1), rgba(234, 236, 254, 0.4), rgba(234, 236, 254, 0));
        }
      }
    }

    .swiper-slide-next {
      .video-wrap {
        &:before {
          position: absolute;
          width: 100%;
          height: 500px;
          content: "";
          display: block;
          z-index: 99;
          margin-top: -10px;
          background: linear-gradient(to left, rgba(224, 238, 253, 1), rgba(224, 238, 253, 1), rgba(224, 238, 253, 1), rgba(224, 238, 253, 0.4), rgba(224, 238, 253, 0));
        }
      }
    }

    .swiper-slide-active {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left:10px;

      .video-wrap {
        &:before {
          position: absolute;
          width: 0;
          height: 0;
          content: "";
          background: none;
        }

      }

      .text-wrap {
        display: flex;
        justify-content: start;
        position: absolute;
        width: 150%;
        max-width: 850px;
        bottom: 10px;
        box-sizing: content-box;

        .name {
          width: 160px;
          text-align: right;
          line-height: 36px;
          font-size: 24px;
          font-weight: 400;
          color: #000000;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border-right: 1px solid rgba(0, 0, 0, 0.6);
          padding-right: 20px;
          margin-right: 20px;
        }

        .desc {
          width: 80%;
          max-width: 560px;
          max-height: 80px;
          text-align: justify;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;

        }
      }

    }

    .video-apply {
      padding-top: 0;
      width: auto;
      height: 450px;
      background-color: none !important;
      background: none !important;
      border: 3px solid #7E9EA1;
      object-fit: fill; //拉伸填充盒子，保证和图片一样大

      &::-internal-media-controls-download-button {
        display: none;
      }

      &::-webkit-media-controls-enclosure {
        overflow: hidden;
        //display: none;
      }

      &::-webkit-media-controls-panel {
        width: calc(100% + 50px);
        //display: none;
      }

      //&::-internal-media-controls-overflow-button{
      //  display: none !important;
      //}
      &::-internal-media-controls-overflow-button {
        display: none !important;
      }


    }

    //更多选项按钮
    video::-internal-media-controls-overflow-menu-list-item {
      position: absolute !important;
      bottom: 30px !important;
      right: 20px !important;
      display: none;
    }


    .swiper-slide-active {
      .play-pause {
        width: 142px;
        height: 142px;
        background: url(../../../public/images/home/play.png) no-repeat;
        //border-radius: 10px;
        position: absolute;
        z-index: 1;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        //cursor: pointer;
      }

      .video-apply {
        height: 340px;
        transform: scaleX(1.4);
        margin-left: -50px;
      }
    }


    ::v-deep.swiper-pagination {
      bottom: 20px;
    }

    ::v-deep.swiper-pagination-bullet {
      width: 76px;
      height: 18px;
      display: inline-block;
      border-radius: 10px;
      margin: 0 30px;
      background: #fff;
      opacity: 1;
    }

    ::v-deep .swiper-pagination-bullet-active {
      background: #919AE7;
    }
  }
}

::v-deep.swiper-button-next:after, ::v-deep.swiper-button-prev:after {
  font-family: swiper-icons;
  font-size: var(--swiper-navigation-size);
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
  color: #fff;
  /* font-size: 66px; */
  font-weight: bolder;
}

::v-deep.swiper-button-prev {
  margin: 0 0 0 250px;
  z-index: 1000;
}

::v-deep.swiper-button-next {
  margin: 0 250px 0 0;
  z-index: 1000;
}

ul.apply {
  overflow: hidden;
  margin-left: -30px;
  margin-bottom: 120px;

  .item {
    margin-left: 30px;
    float: left;
    width: 380px;
    height: 480px;
    background: #fff;

    .link {
      .img {
        width: 380px;
        height: 240px;
      }

      .title {
        display: inline-block;
        width: 100%;
        margin: 24px 0;
        font-size: 22px;
        color: #333;
        font-weight: bold;
      }

      .content {
        display: inline-block;
        text-align: left;
        line-height: 28px;
        font-size: 18px;
        color: #555;
        padding: 0 30px;
        box-sizing: border-box;
        margin: 0;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
      }

      &:hover {
        .title {
          color: #3c7dff;
        }

        .content {
          color: #3c7dff;
        }
      }
    }
  }
}
</style>
